(function () {
  const STYLE_ID = "custom-shopify-forms-styles";

const CUSTOM_CSS = `
:host {
  width: 100% !important;
  max-width: 900px !important;
  display: block !important;
  margin: 0 auto !important;
}

#app-embed,
[data-testid="app-router"],
#form-container-ref,
section,
form {
  width: 100% !important;
  max-width: 900px !important;
  margin-left: auto !important;
  margin-right: auto !important;
 
}


h2 {
  text-transform: uppercase !important;
  font-size: 34px !important;
  line-height: 1.2 !important;
  color: #f39208 !important;
}

fieldset,
[data-testid="form"] > * {
  margin-bottom: 20px !important;
}

section[class*="inline"] {
  grid-template-columns: 1fr !important;
}

@media screen and (max-width: 767px) {
  :host {
    max-width: calc(100% - 36px) !important;
  }

  #app-embed,
  [data-testid="app-router"],
  #form-container-ref,
  section,
  form {
    max-width: 100% !important;
  }
}

`;

  function injectStyles() {
    document.querySelectorAll("shopify-forms-embed").forEach((embed) => {
      const root = embed.shadowRoot;
      if (!root) return;

      let style = root.getElementById(STYLE_ID);

      if (!style) {
        style = document.createElement("style");
        style.id = STYLE_ID;
        root.appendChild(style);
      }

      style.textContent = CUSTOM_CSS;
    });
  }

  injectStyles();

  document.addEventListener("DOMContentLoaded", injectStyles);
  window.addEventListener("load", injectStyles);

  new MutationObserver(injectStyles).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();